import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';

export default function Register() {
  // Registro público: rol fijo 'student'. El backend además rechaza cualquier otro rol.
  const [form, setForm] = useState({ first_name:'', last_name:'', email:'', password:'', role:'student' });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await register(form);
      toast.success(`¡Bienvenido, ${user.first_name}!`);
      nav('/app');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al registrarse');
    } finally { setLoading(false); }
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6">
      <Card className="w-full max-w-lg border-slate-200">
        <CardHeader>
          <CardTitle className="font-display text-3xl font-extrabold">Crear cuenta</CardTitle>
          <p className="text-sm text-slate-500">Únete a Chess4Kings Academy.</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label>Nombre</Label>
                <Input data-testid="register-first-name" value={form.first_name} onChange={(e)=>set('first_name', e.target.value)} required />
              </div>
              <div>
                <Label>Apellido</Label>
                <Input data-testid="register-last-name" value={form.last_name} onChange={(e)=>set('last_name', e.target.value)} required />
              </div>
            </div>
            <div>
              <Label>Email</Label>
              <Input data-testid="register-email" type="email" value={form.email} onChange={(e)=>set('email', e.target.value)} required />
            </div>
            <div>
              <Label>Contraseña</Label>
              <Input data-testid="register-password" type="password" value={form.password} onChange={(e)=>set('password', e.target.value)} required minLength={6}/>
            </div>
            <p className="text-xs text-slate-500" data-testid="register-role-note">
              El registro público es únicamente para alumnos. Los profesores y administradores son creados por el equipo de Chess4Kings.
            </p>
            <Button data-testid="register-submit" type="submit" disabled={loading} className="w-full rounded-full bg-blue-600 hover:bg-blue-700 border-b-4 border-blue-800 btn-tactile h-11 font-bold">
              {loading ? 'Creando…' : 'Crear cuenta'}
            </Button>
            <div className="text-sm text-slate-500 text-center">
              ¿Ya tienes cuenta? <Link to="/login" className="text-blue-600 font-semibold">Iniciar sesión</Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
